import {View} from 'MWC';
import mainTpl from '../../templates/order/gold';

class OrderGold extends View {
    template = mainTpl;

    static displayName = 'Cards.Views.OrderGold';
}

export default OrderGold;
